import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { useAppDispatch } from './useAppDispatch';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { equals } from 'ramda';

export const useJsonQueryBackup = () => {
  const dispatch = useAppDispatch();
  const jsonQuery = useSelector(selectJsonQuery);
  const [jsonQueryBackup] = useState(jsonQuery);

  const resetJsonQuery = useCallback(() => {
    dispatch(setJsonQuery(jsonQueryBackup));

    if (!equals(jsonQuery, jsonQueryBackup)) {
      dispatch(updateSearchMeta());
    }
  }, [dispatch, jsonQuery, jsonQueryBackup]);

  return useMemo(() => ({ jsonQueryBackup, resetJsonQuery }), [jsonQueryBackup, resetJsonQuery]);
};
